import clsx from "clsx";
import { twMerge } from "tailwind-merge";

type Tone = "info" | "success" | "warning" | "danger" | "neutral";

const map: Record<Tone, string> = {
  info:    "bg-brand-50 text-brand-700 ring-brand-100",
  success: "bg-success-50 text-success-700 ring-success-100",
  warning: "bg-warning-50 text-warning-700 ring-warning-100",
  danger:  "bg-danger-50 text-danger-700 ring-danger-100",
  neutral: "bg-surface-100 text-surface-700 ring-surface-200",
};

export function Badge({
  tone = "neutral", children, className,
}: React.PropsWithChildren<{ tone?: Tone; className?: string }>) {
  return (
    <span className={twMerge(clsx(
      "inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-2xs font-semibold uppercase tracking-wide ring-1 ring-inset",
      map[tone], className,
    ))}>
      {children}
    </span>
  );
}
